import { css } from '@emotion/react'
import styled from '@emotion/styled'
import theme from '../../../styles/theme'
import {
  TextMediumMini500Style,
  TextMediumMaxi500Style,
  InfoExtraSmall500Style,
  InfoSmall500Style,
  TextMediumMini400FadedStyle,
  TextMediumMini400Style,
  TextMediumMaxi600Style,
  TextMediumMini600Style,
} from '../../../styles/Text.styles'

/*
 * These are utility components for the versatile grid ment to be used inside cells,
 * exposed to the end react component who uses the grid.
 * Here we can reuse the same styles for different types of data in the grid.
 */
export const GridCellBoldText = styled.span`
  ${TextMediumMini500Style};
`

export const GridCellProminantText = styled.span`
  ${TextMediumMaxi600Style};
  color: ${theme.colors.fadedText};
`

export const GridCellHeaderProminantText = styled.span`
  ${TextMediumMaxi500Style};
  color: ${theme.colors.fadedText};
`

export const GridCellAlmostProminantText = styled.span`
  ${TextMediumMini600Style};
  color: ${theme.colors.veryFadedText};
`

export const GridCellSmallFadedText = styled.span`
  ${TextMediumMini400FadedStyle};
`

export const GridCellNormalText = styled.span`
  ${TextMediumMini400Style};
  text-transform: capitalize;
`

export const GridCellNormalTextFaded = styled.span`
  ${TextMediumMini400Style};
  color: ${theme.colors.veryVeryFadedText};
`

export const ListInVersatileGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const StatsContainer = styled.div`
  display: flex;
  gap: 1rem;
  min-width: 20rem;
  width: 100%;
  //make items move away from each other
  height: 5rem;
  align-items: center;
`

export const FilterRadioRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`

export const FilterRadioLabel = styled.label`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  cursor: pointer;
  ${InfoSmall500Style};
`

export const ListInVersatileGridStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const ListItemInVersatileGrid = styled.div`
  display: flex;
  align-items: top;
  gap: 10px;
`

export const ExpandButton = styled.button`
  ${InfoExtraSmall500Style}
  background: ${theme.colors.background};
  color: ${theme.colors.veryVeryVeryFadedText};
  min-width: 3.2rem;
  border-radius: 8px;
  padding-right: 0.6rem;
  cursor: pointer;
  margin: 0.5rem;
  border: none;

  &:hover {
    color: ${theme.colors.standardText};
  }
`

export const ExpandButtonKeeper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Ellipsis = styled.span`
  color: ${(props) => theme.colors.veryFadedText};
  text-align: center;
  width: 100%;
  line-height: 0.5rem;
`
